// extracted by mini-css-extract-plugin
export default {"rebate":"CartSuggest-rebate_jEA6X"};